import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
const usePluggableSharedEntityTableElements = () => {
  const pluginTableElements = usePluginEntities("components.permission.shared.entity.tableElements");
  const tableElements = pluginTableElements.filter((action) => action.useCondition ? !!action.useCondition() : true);
  const pluggableAttributes = tableElements.reduce((acc, curr) => [...acc, ...curr.attributes], []);
  const pluggableAttributeNames = tableElements.reduce((acc, curr) => [...acc, curr.attributeName], []);
  const getPluggableTableCells = (entityId, entityType) => tableElements.reduce(
    (acc, curr) => [
      ...acc,
      {
        component: curr.tableCellComponent
      }
    ],
    []
  ).map(({ component: PluggableTableCell }) => /* @__PURE__ */ React.createElement(PluggableTableCell, { key: entityId, entityId, entityType }));
  const pluggableTableHeaders = tableElements.reduce((acc, curr) => [...acc, ...curr.attributes], []).map((attribute) => /* @__PURE__ */ React.createElement("th", { key: attribute.id, className: `entity-table-header-${attribute.id}` }, attribute.title));
  return {
    pluggableAttributes: {
      attributeNames: pluggableAttributeNames,
      attributes: pluggableAttributes
    },
    getPluggableTableCells,
    pluggableTableHeaders
  };
};
export default usePluggableSharedEntityTableElements;
